import React from 'react'
import ImagePlacholder from '../assetsComponents/ImagePlacholder'
import { isPdfFile, isImageFile } from '../../utils/fileValidation'

/**
 * Reusable file preview component
 * Displays preview for images and PDFs
 */
const FilePreview = ({
  file,
  previewUrl,
  fileName,
  uploadedPreviewUrl,
  onDelete,
  onView,
  showDeleteButton = true,
  className = '',
}) => {
  const isPdf = isPdfFile(file) || (fileName && fileName.endsWith('.pdf'))
  const imageUrl = previewUrl || uploadedPreviewUrl

  const handleClick = () => {
    if (onView && (isPdf || imageUrl)) {
      onView()
    }
  }

  return (
    <div
      className={`p-2 bg-gray-100 border-radius-5 position-relative pb-3 ${className}`}
      style={{
        height: '322px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
      }}>
      {/* Preview Content */}
      {isPdf ? (
        <div
          style={{
            width: '100%',
            height: '240px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f8f9fa',
            border: '1px solid #ddd',
            borderRadius: '4px',
            cursor: onView ? 'pointer' : 'default',
          }}
          onClick={handleClick}
          title={onView ? 'Click to view PDF in new tab' : ''}>
          <svg
            width='60'
            height='60'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0_16599_21131)'>
              <path
                d='M4.66667 10.6673H4V9.33398H4.66667C5.03485 9.33398 5.33333 9.63246 5.33333 10.0007C5.33333 10.3688 5.03485 10.6673 4.66667 10.6673Z'
                fill='currentColor'
              />
              <path
                d='M9.33203 13.334V9.33398H9.9987C10.3669 9.33398 10.6654 9.63246 10.6654 10.0007V12.6673C10.6654 13.0355 10.3669 13.334 9.9987 13.334H9.33203Z'
                fill='currentColor'
              />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M1.33203 2C1.33203 0.895431 2.22746 0 3.33203 0H14.2748L18.6654 4.39052V18C18.6654 19.1045 17.7699 20 16.6654 20H3.33203C2.22746 20 1.33203 19.1045 1.33203 18V2ZM4.66536 8H2.66536V14.6667H3.9987V12H4.66536C5.76994 12 6.66536 11.1046 6.66536 10C6.66536 8.89543 5.76994 8 4.66536 8ZM9.9987 8H7.9987V14.6667H9.9987C11.1033 14.6667 11.9987 13.7712 11.9987 12.6667V10C11.9987 8.89543 11.1033 8 9.9987 8ZM13.332 14.6667V8H17.332V9.33333H14.6654V10.6667H15.9987V12H14.6654V14.6667H13.332Z'
                fill='currentColor'
              />
            </g>
            <defs>
              <clipPath id='clip0_16599_21131'>
                <rect width='20' height='20' fill='white' />
              </clipPath>
            </defs>
          </svg>
        </div>
      ) : imageUrl ? (
        <img
          className='border-radius-5'
          src={imageUrl}
          alt={isImageFile(file) ? 'File preview' : 'insurance img'}
          style={{
            width: '100%',
            height: '240px',
            aspectRatio: '1.54',
            objectFit: 'cover',
            objectPosition: 'center top',
            border: '1px solid #ddd',
            borderRadius: '4px',
            background: '#f8f9fa',
            cursor: onView ? 'pointer' : 'default',
          }}
          onClick={handleClick}
          title={onView ? 'Click to view image in new tab' : ''}
        />
      ) : (
        <ImagePlacholder />
      )}

      {/* Delete Button */}
      {showDeleteButton && onDelete && (
        <div
          className='position-absolute top-12px right-12px'
          onClick={onDelete}
          style={{ cursor: 'pointer' }}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'>
            <rect
              x='24'
              y='24'
              width='24'
              height='24'
              rx='12'
              transform='rotate(-180 24 24)'
              fill='#EBEBEB'
            />
            <path d='M17 7L7 17' stroke='black' strokeLinecap='round' />
            <path d='M17 17L7 7' stroke='black' strokeLinecap='round' />
          </svg>
        </div>
      )}

      {/* File Name */}
      {fileName && (
        <div
          className='s8 mt-3 cursor-pointer'
          onClick={handleClick}
          style={{ cursor: onView ? 'pointer' : 'default' }}>
          {fileName.length > 30 ? fileName.slice(0, 30) + '...' : fileName}
        </div>
      )}
    </div>
  )
}

export default FilePreview
